import { StatusTag, rem, useGlobalization } from '@innovyze/stylovyze';
import React from 'react';

interface StatusCellProps {
	status: string;
}

export const StatusCell = ({ status }: StatusCellProps) => {
	const { t } = useGlobalization();
	const value = parseInt(status);
	switch (value) {
		case 0:
			return (
				<StatusTag
					text={t('Optimal')}
					color="negligible"
					width={rem(92)}
				/>
			);
		case 1:
			return <StatusTag text={t('Stable')} color="low" width={rem(92)} />;
		case 2:
			return (
				<StatusTag
					text={t('Moderate')}
					color="medium"
					width={rem(92)}
				/>
			);
		case 3:
			return (
				<StatusTag
					text={t('Concerning')}
					color="high"
					width={rem(92)}
				/>
			);
		case 4:
			return (
				<StatusTag
					text={t('Critical')}
					color="extreme"
					width={rem(92)}
				/>
			);
		default:
			return <></>;
	}
};
